import type { ReactNode } from "react";
import { Container, Grid } from "@mui/material";
import PageTitle from "components/PageTitle";
import { Authorization } from "@sdeapps/react-core";
import { ApplicationRole } from "constants/ApplicationRole";
import { withPageErrorBoundary } from "utils/errorHandling";
import { AffectationAntenneCommunesForm } from "./components/AffectationAntenneCommunesForm";

function AffectationAntenne(): ReactNode {
  return (
    <Container>
      <Authorization roles={ApplicationRole.ADMINISTRATOR}>
        <Grid container spacing={2}>
          <PageTitle title="Affectation de communes à une antenne" />
          <Grid container size={12}>
            <AffectationAntenneCommunesForm />
          </Grid>
        </Grid>
      </Authorization>
    </Container>
  );
}

const AffectationAntenneWithErrorBoundary = withPageErrorBoundary(AffectationAntenne);

export default AffectationAntenneWithErrorBoundary;
